import { ContentType } from "@authory-packages/core";
import { V3IconArticle, V3IconPodcast, V3IconVideo, V3IconPost, V3IconImage, V3IconPDF, V3IconWebsiteEmail, V3IconBook } from "../Icons";

export const getThumbnaiPlaceholderIcon = (type: ContentType) => {
    switch (type) {
        case ContentType.Article:
            return <V3IconArticle />;
        case ContentType.PodcastItem:
        case ContentType.Audio:
            return <V3IconPodcast />;
        case ContentType.Video:
        case ContentType.VideoPost:
            return <V3IconVideo />;
        case ContentType.TextPost:
        case ContentType.ReplyPost:
            return <V3IconPost />;
        case ContentType.ImagePost:
            return <V3IconImage />;
        case ContentType.PdfFile:
            return <V3IconPDF />;
        case ContentType.Image:
            return <V3IconWebsiteEmail />;
        case ContentType.Book:
            return <V3IconBook />;
        default:
            return <></>;
    }
};
